import DealCompForm from './DealCompForm'

export default DealCompForm;